// officeMember.reducer.js
import { officeMemberConstants as C } from "../actions/constants";

const initialState = {
    membersByOffice: {},
    currentMemberByOffice: {},
    permissionsByOffice: {},
    memberships: [],
    roles: [
        "owner",
        "admin",
        "manager",
        "sales",
        "installer",
        "driver",
        "warehouse",
        "accountant",
        "worker",
    ],
    loading: false,
    actionLoading: false,
    error: null,
};

const getId = (value) => String(value?._id || value?.id || value || "");

const upsertMember = (list = [], member) => {
    if (!member) return list;

    const id = getId(member);
    const exists = list.some((item) => getId(item) === id);

    if (!exists) {
        return [member, ...list];
    }

    return list.map((item) => (getId(item) === id ? member : item));
};

const removeMember = (list = [], memberId) => {
    const id = getId(memberId);

    return list.filter((item) => getId(item) !== id);
};

export default function officeMemberReducer(state = initialState, action) {
    switch (action.type) {
        case C.CLEAR_OFFICE_MEMBERS_ERROR:
            return {
                ...state,
                error: null,
            };

        case C.GET_OFFICE_MEMBERS_REQUEST:
        case C.GET_MY_OFFICE_MEMBERSHIPS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case C.ADD_OFFICE_MEMBER_REQUEST:
        case C.UPDATE_OFFICE_MEMBER_REQUEST:
        case C.REMOVE_OFFICE_MEMBER_REQUEST:
        case C.REBUILD_OFFICE_MEMBERS_REQUEST:
            return {
                ...state,
                actionLoading: true,
                error: null,
            };

        case C.GET_OFFICE_MEMBERS_SUCCESS:
            return {
                ...state,
                loading: false,
                membersByOffice: {
                    ...state.membersByOffice,
                    [action.payload.officeId]: action.payload.members || [],
                },
                currentMemberByOffice: {
                    ...state.currentMemberByOffice,
                    [action.payload.officeId]: action.payload.currentMember || null,
                },
                permissionsByOffice: {
                    ...state.permissionsByOffice,
                    [action.payload.officeId]: action.payload.permissions || {},
                },
                roles: Array.isArray(action.payload.roles) && action.payload.roles.length
                    ? action.payload.roles
                    : state.roles,
                error: null,
            };

        case C.ADD_OFFICE_MEMBER_SUCCESS:
        case C.UPDATE_OFFICE_MEMBER_SUCCESS: {
            const officeId = action.payload.officeId;
            const currentList = state.membersByOffice[officeId] || [];

            return {
                ...state,
                actionLoading: false,
                membersByOffice: {
                    ...state.membersByOffice,
                    [officeId]: upsertMember(currentList, action.payload.member),
                },
                error: null,
            };
        }

        case C.REMOVE_OFFICE_MEMBER_SUCCESS: {
            const officeId = action.payload.officeId;
            const currentList = state.membersByOffice[officeId] || [];

            return {
                ...state,
                actionLoading: false,
                membersByOffice: {
                    ...state.membersByOffice,
                    [officeId]: removeMember(currentList, action.payload.memberId),
                },
                error: null,
            };
        }

        case C.GET_MY_OFFICE_MEMBERSHIPS_SUCCESS:
            return {
                ...state,
                loading: false,
                memberships: action.payload.memberships || [],
                error: null,
            };

        case C.REBUILD_OFFICE_MEMBERS_SUCCESS:
            return {
                ...state,
                actionLoading: false,
                error: null,
            };

        case C.GET_OFFICE_MEMBERS_FAILURE:
        case C.GET_MY_OFFICE_MEMBERSHIPS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.error || "Ошибка загрузки сотрудников",
            };

        case C.ADD_OFFICE_MEMBER_FAILURE:
        case C.UPDATE_OFFICE_MEMBER_FAILURE:
        case C.REMOVE_OFFICE_MEMBER_FAILURE:
        case C.REBUILD_OFFICE_MEMBERS_FAILURE:
            return {
                ...state,
                actionLoading: false,
                error: action.payload?.error || "Ошибка операции с сотрудником",
            };

        default:
            return state;
    }
}